import APP_ACTIONS from '../constants/app-actions';
import ProductModel from '../services/product-model';

const initialState = {
    products: [],
    allStoreProducts: [],
    meta: {},
};

const productList = (state = initialState, action) => {
    let newProductList;
    let productInList;
    let oldProductList;

    switch (action.type) {
    case APP_ACTIONS.ADD_PRODUCTS:
        return { ...state, products: action.payload.products, meta: action.payload.meta };

    case APP_ACTIONS.APPEND_PRODUCTS:
        oldProductList = state.products.map((oldProduct) => oldProduct.id);
        newProductList = action.payload.products.filter((product) => oldProductList.indexOf(product.id) === -1);

        return {
            ...state,
            products: [...state.products, ...newProductList],
        };

    case APP_ACTIONS.ADD_PRODUCT:
        productInList = ProductModel.find(action.payload.id, state.products);

        if (productInList) {
            return state;
        }

        newProductList = Object.assign([], state.products);
        newProductList.push(action.payload);

        return { ...state, products: newProductList };

    case APP_ACTIONS.ADD_PRODUCTS_FROM_ALL_STORES:
        return { ...state, allStoreProducts: action.payload.allStoreProducts, meta: action.payload.meta };

    default:
        return state;
    }
};

export default productList;



/** WEBPACK FOOTER **
 ** ./src/reducers/product-list.js
 **/